import { Component, Inject, LOCALE_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';

import { AbstractBiditComponent } from '../abstract.bidit.component';

@Component({
  selector: 'app-print-language-dialog',
  templateUrl: './print.language.dialog.html',
  styleUrls: ['./print.language.dialog.scss']
})
export class PrintLanguageDialog extends AbstractBiditComponent {

  locale: string = 'en';

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<PrintLanguageDialog>) {
    super(deviceDetectorService);

    this.locale = locale;
  }

  printReport(): void {
    this.dialogRef.close(this.locale);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
